<template>
  <div v-if="draggable">
    <right-panel
      v-if="recommendations && recommendations.docs.length > 0"
      class="float-left"
      id="sidebar-department-recommendation"
      width="650px"
      :icon="'mdi mdi-plus'"
      :text="$t('common.recommendations')"
      @hidden="rightPanelClosed"
    >
      <div class="pl-5 pr-5">
        <div class="mt-4 mb-3">
          <h6>{{ $t("common.recommendations") }}</h6>

          <content-loading v-if="isLoading" />
          <empty v-if="!isLoading && (!recommendations || recommendations.docs.length == 0)" width="100px" />
          <div v-if="recommendations">
            <b-card v-for="item in recommendations.docs" no-body class="custom-accordion shadow-none mb-1" :key="item._id">
              <b-card-body class="p-2 hider">
                <i class="mdi mdi-plus float-right text-success hand hidden" v-b-tooltip.hover :title="$t('common.add-to-organization')" @click="addFromLibrary(item)"></i>

                <h6 class="">
                  <i v-if="item.scope.value == 'workspace'" v-b-tooltip.hover :title="$t('workspace.yours')" class="text-muted mdi mdi-hexagon-multiple-outline"></i>
                  <i v-else class="text-muted mdi mdi-database" v-b-tooltip.hover :title="$t('library.belonging-to-the-system')"></i>
                  {{ item.name | translate }}
                </h6>
              </b-card-body>
            </b-card>

            <!-- Begin: Pagination -->

            <div class="row">
              <div class="col">
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    v-model="recommendationRequest.options.page"
                    :total-rows="recommendations.totalDocs"
                    :per-page="recommendations.limit"
                    limit="10"
                    size="sm"
                  ></b-pagination>
                </ul>
              </div>
            </div>
            <!-- End: Pagination -->
          </div>
        </div>
      </div>
    </right-panel>
  </div>
</template>

<script>
export default {
  props: ["rightPanelId", "organizationScopedState", "libraryScopedState", "level", "id", "draggable"],
  data() {
    return {
      recommendationRequest: {
        options: { page: 1, limit: 20 },
        query: {},
      },
    };
  },

  watch: {
    recommendationRequest: {
      deep: true,
      immediate: true,

      handler() {
        this.debounceMixin(() => this.fethcRecommendation());
      },
    },
  },

  computed: {
    recommendations() {
      return this.$store.getters[`${this.libraryScopedState}/recommendations`];
    },
    isLoading() {
      return this.$store.getters[`${this.libraryScopedState}/isLoading`];
    },
  },
  mounted() {
    this.fethcRecommendation();
  },
  methods: {
    rightPanelClosed() {
      this.$store.commit(`department/editedEntity`, null);
    },
    fethcRecommendation() {
      this.$store.dispatch(`${this.libraryScopedState}/paginateRecommendation`, { pagination: this.recommendationRequest, level: this.level, id: this.id });
    },

    async addFromLibrary(libraryItem) {
      try {
        const payload = {
          libraryItem,
        };
        this.$emit("interceptForSetParent", payload);
        await this.$store.dispatch(`${this.organizationScopedState}/addFromLibrary`, payload);
        this.form = {};
        this.$toast.success("'" + this.$options.filters.translate(libraryItem.name) + "' Eklendi");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>

<style scoped>
.badge {
  font-weight: bold !important ;
}
</style>
